var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
  className: "style-fonts"
}, "\n      @font-face {\n        font-family: \"Virgil\";\n        src: url(\"https://excalidraw.com/Virgil.woff2\");\n      }\n      @font-face {\n        font-family: \"Cascadia\";\n        src: url(\"https://excalidraw.com/Cascadia.woff2\");\n      }\n    "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.125233273822232 10) rotate(0 -2.773922913998831 5.302055190047668)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C-0.92 1.77, -4.62 8.84, -5.55 10.6 M0 0 C-0.92 1.77, -4.62 8.84, -5.55 10.6",
  stroke: "black",
  strokeWidth: 1,
  fill: "none"
})));
var _ref4 = /*#__PURE__*/React.createElement("mask", null);
var _ref5 = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.547845827997662 21.361014968846575) rotate(0 -2.773922913998831 5.302055190047668)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C-0.92 1.77, -4.62 8.84, -5.55 10.6 M0 0 C-0.92 1.77, -4.62 8.84, -5.55 10.6",
  stroke: "black",
  strokeWidth: 1,
  fill: "none"
})));
var _ref6 = /*#__PURE__*/React.createElement("mask", null);
var _ref7 = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.647613342385739 20.814788069768838) rotate(0 2.317454586378517 0.14045179311369793)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.77 0.05, 3.86 0.23, 4.63 0.28 M0 0 C0.77 0.05, 3.86 0.23, 4.63 0.28",
  stroke: "black",
  strokeWidth: 1,
  fill: "none"
})));
var _ref8 = /*#__PURE__*/React.createElement("mask", null);
var _ref9 = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.406136860052356 10.000000000001819) rotate(0 -0.42135537934154854 3.897537258909324)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C-0.14 1.3, -0.7 6.5, -0.84 7.8 M0 0 C-0.14 1.3, -0.7 6.5, -0.84 7.8",
  stroke: "black",
  strokeWidth: 1,
  fill: "none"
})));
var _ref10 = /*#__PURE__*/React.createElement("mask", null);
var _ref11 = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.08580616992549 31.980705622318055) rotate(0 5.196716345211826 -6.811911966021398)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C1.73 -2.27, 8.66 -11.35, 10.39 -13.62 M0 0 C1.73 -2.27, 8.66 -11.35, 10.39 -13.62",
  stroke: "black",
  strokeWidth: 1,
  fill: "none"
})));
var _ref12 = /*#__PURE__*/React.createElement("mask", null);
var _ref13 = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.56342610136926 17.93552631093189) rotate(0 2.4930193277705257 0.14045179311369793)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0 C0.83 0.05, 4.16 0.23, 4.99 0.28 M0 0 C0.83 0.05, 4.16 0.23, 4.99 0.28",
  stroke: "black",
  strokeWidth: 1,
  fill: "none"
})));
var _ref14 = /*#__PURE__*/React.createElement("mask", null);
function SvgBlackLightning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.54946475691031 41.980705622318055",
    width: 91.64839427073093,
    height: 125.94211686695417,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLightning);
export default __webpack_public_path__ + "static/media/black_lightning.776f9bd786dcba3ed7381bd544592c5b.svg";
export { ForwardRef as ReactComponent };